import api from '../../services/api';

/**
 * Get team members and pending invitations
 */
export async function getTeam() {
  const response = await api.get('/attorney/team');
  return response.data;
}

/**
 * Invite a new member to the organization
 * @param {string} email - Email address to invite
 * @param {string} role - Role to assign (org:admin, org:attorney)
 */
export async function inviteMember(email, role = 'org:attorney') {
  const response = await api.post('/attorney/team/invite', { email, role });
  return response.data;
}

/**
 * Cancel a pending invitation
 * @param {string} invitationId - Invitation ID to cancel
 */
export async function cancelInvitation(invitationId) {
  const response = await api.delete(`/attorney/team/invitations/${invitationId}`);
  return response.data;
}

/**
 * Remove a member from the organization
 * @param {string} userId - User ID to remove
 */
export async function removeMember(userId) {
  const response = await api.delete(`/attorney/team/members/${userId}`);
  return response.data;
}

export default {
  getTeam,
  inviteMember,
  cancelInvitation,
  removeMember
};
